import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { SharedService } from 'src/app/services/shared.service';
import { SocketsService } from 'src/app/services/socket.service';
import { Email } from 'src/app/shared/regex';
import { SharedModule } from 'src/app/shared/shared.module';
import { currency } from 'src/app/services/shared.service';

@Component({
    selector: 'app-dashboard-modal',
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        RouterModule,],
    templateUrl: './dashboard-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dashboard-modal.component.scss'
})
export class DashboardModalComponent implements OnChanges, OnDestroy {
  @Input() modalType: 'VERIFY_EMAIL' | 'UPDATE_EMAIL' | 'RESENT_EMAIL' = 'VERIFY_EMAIL';
  @Output() closed = new EventEmitter<void>();
  @ViewChild('CONFIRM_ACCEPT_OFFER') CONFIRM_ACCEPT_OFFER!: TemplateRef<any>;
  @Input() triggerApiInModal = false;
  @Input() showUpfrontPreview: boolean = false;
  @Output() onSuccessFetch = new EventEmitter<{ offerData: any[]; isSuccess: boolean;}>();

  @Input() selectedUpfrontIds: any[] = [];
  @Input() fromPage: 'dashboard' | 'contract_details' = 'dashboard';
  @Input() currency_data!: currency;
  @Output() closeUpfrontPreview = new EventEmitter<void>();

  updateEmailForm!: UntypedFormGroup;
  userProfile: any;
  agentData: any;
  isUpfrontConsentChecked = false;
  @Input() isModalPreview = true;
  select_all_upfront: boolean = false;

  upfrontOffers: any[] = [];
  selectedPlansSummary: any = {
    total_upfront_amount: 0,
    total_face_value: 0,
    total_payments: 0,
    selected_contracts: 0,
    total_payout_amount: 0,
  };
  private modalSelectedUpfrontIds: number[] = [];
  private backToDashboardTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['triggerApiInModal']?.currentValue === false) {
      return;
    }
    if (!this.triggerApiInModal) {
      return;
    }
    if (
      changes['triggerApiInModal'] ||
      changes['selectedUpfrontIds'] ||
      changes['showUpfrontPreview']
    ) {
      this.runTriggeredLendeeOfferFetch();
    }
  }

  private runTriggeredLendeeOfferFetch(): void {
    if (!this.triggerApiInModal || !this.selectedUpfrontIds?.length) {
      return;
    }
    this.clearBackToDashboardTimer();
    this.isModalPreview = false;
    this.modalSelectedUpfrontIds = [...this.selectedUpfrontIds];
    this.fetchLendeeOffer();
  }

  constructor(
    private bsModalRef: BsModalRef,
    private _shared: SharedService,
    private _modal: BsModalService,
    private _local: localStorageService,
    private _api: ApiService,
    private fb: UntypedFormBuilder,
    private _socket: SocketsService
  ) {
    this.userProfile = this._local.customGetItem('userProfileData');
    this.agentData = this._local.customGetItem('userDoctorData');
    this.updateEmailForm = this.fb.group({
      doctor_email: [this.userProfile?.doctor_email || '', [Validators.required, Validators.email]]
    });
  }

  // ngOnInit(): void {
  //   setTimeout(() => {
  //     if (!this.triggered && this.modalType === 'VERIFY_EMAIL') {
  //       this.triggered = true;
  //       if (this.userProfile.email_verified === 0) {
  //         this.saveEmail();
  //       }
  //     }
  //   });
  // }

  close() {
    // if (this.userProfile && this.userProfile.email_verified === 0) {
    //   this.userProfile.email_verified = 1;
    //   this._local.customSetItem('userProfileData', this.userProfile);
    // }
    this.clearBackToDashboardTimer();
    this.isModalPreview = this.fromPage !== 'contract_details';
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    this.closed.emit();
  }

  editEmail() {
    this.modalType = 'UPDATE_EMAIL';
    this.updateEmailForm.patchValue({ doctor_email: this.userProfile.doctor_email });
  }

  saveEmail() {
    // if (this.userProfile && this.userProfile.email_verified === 0) {
    //   this.userProfile.email_verified = 1;
    //   this._local.customSetItem('userProfileData', this.userProfile);
    // }

    if (this.updateEmailForm.invalid) {
      this.updateEmailForm.markAllAsTouched();
      return;
    }

    const updatedEmail = this.updateEmailForm.value.doctor_email;
    const oldEmail = this.userProfile.doctor_email;
    const isChecked = oldEmail === updatedEmail ? 1 : 0;

    const data = {
      doctor_email: updatedEmail,
      doctor_id: this.userProfile.doctor_id,
      isChecked: isChecked
    };

    this._api.api(data, 'auth/send_otp_number_v2').subscribe({
      next: (response: any) => {
        if (response && !response.is_error) {
           this.modalType = 'RESENT_EMAIL';
        
          if(response?.access_token){
            this._local.customSetItem('token', response.access_token);
          }
        //  if (param === 2) {
        //   this.bsModalRef.hide();  
        // } else {
        //   this.modalType = 'VERIFY_EMAIL'; 
        // }
          // if (this.userProfile.email_verified === 1) {
          //   this._shared.customPopups('Email Sent successfully', 0);
          // }
          // this.bsModalRef.hide();
          setTimeout(() => {
              if (this.userProfile && this.userProfile.email_verified === 0) {
            this.userProfile.email_verified = 1;
          }
          this.userProfile.doctor_email = updatedEmail;
          this._local.customSetItem('userProfileData', this.userProfile);
            this.close();
          }, 2000); 
          this._socket.emit('DOCTOR_CONNECTED',{socket_id : this._shared.socketIds.DOCTOR_CONNECTED , doctor_id : this.userProfile.doctor_id})
        }
      },
      error: () => alert('Failed to send verification link')
    });
  }

  resendEmailLink() {
    const data = {
      doctor_email: this.userProfile.doctor_email,
      doctor_id: this.userProfile.doctor_id,
      resend: true
    };

    this._api.api(data, 'auth/send_otp_number_v2').subscribe({
      next: (response: any) => {
        if (response && !response.is_error) {
          this.modalType = 'RESENT_EMAIL';
          setTimeout(() => {
            this.close();
          }, 2000);
        }
      },
      error: () => alert('Failed to resend verification link')
    });
  }
  fetchLendeeOffer(): void {
    if (this.modalSelectedUpfrontIds.length === 0) {
      this._shared.customPopups('Please select at least one contract.', 1);
      return
    }

    const payload = {
      "lo_id_arr": JSON.stringify(this.modalSelectedUpfrontIds),
    };
    console.log(payload);
    this._api.api(payload, 'profile/fetch_lendee_offer_data', 'get').subscribe((data: any) => {
      if (data && data.is_error == 0) {
        this.upfrontOffers = data?.data.offer_list || [];
        this.modalSelectedUpfrontIds = [];
        this.selectedPlansSummary = {
          ...this.selectedPlansSummary,
          total_upfront_amount: 0,
          total_payments: 0,
          selected_contracts: 0,
          total_payout_amount: 0,
          total_face_value: data?.data?.total_face_value ? Number(data.data.total_face_value) : 0,
        };
        this.upfrontOffers.forEach((offer: any) => {
          offer.checked = true;
        });
        this.normalizeUpfrontSelectionState();
        this.onSuccessFetch.emit({offerData: this.upfrontOffers , isSuccess: true});
      }
    });
  }
  private normalizeUpfrontSelectionState(): void {
    const selectedIds = new Set<number>();
    this.upfrontOffers.forEach((offer: any) => {
      if (!offer.checked) {
        return;
      }
      const normalizedOfferId = Number(offer.lo_id);
      if (!Number.isNaN(normalizedOfferId)) {
        selectedIds.add(normalizedOfferId);
      }
    });

    this.modalSelectedUpfrontIds = Array.from(selectedIds);
    this.select_all_upfront =
      this.upfrontOffers.length > 0 &&
      this.upfrontOffers.every((offer: any) => !!offer.checked);
    this.syncSelectedPlansSummaryFromOffers();
  }

  private syncSelectedPlansSummaryFromOffers(): void {
    const selectedOffers = this.upfrontOffers.filter((offer: any) => !!offer.checked);

    const totals = selectedOffers.reduce(
      (acc: any, offer: any) => {
        acc.total_upfront_amount += Number(offer.remaining_amount || 0);
        acc.total_payout_amount += Number((offer.available_share) || 0);
        acc.total_payments += Number(offer.offer_duration_months || 0);
        return acc;
      },
      {
        total_upfront_amount: 0,
        total_payout_amount: 0,
        total_payments: 0,
      }
    );

    this.selectedPlansSummary = {
      ...this.selectedPlansSummary,
      total_upfront_amount: totals.total_upfront_amount,
      total_payout_amount: totals.total_payout_amount,
      total_payments: totals.total_payments,
      selected_contracts: selectedOffers.length,
    };
  }

   toggleSelectAllUpfront(isChecked: boolean): void {
    this.upfrontOffers.forEach((offer: any) => {
      offer.checked = isChecked;
    });
    this.normalizeUpfrontSelectionState();
  }

  toggleUpfrontContractSelection(lo_id: number, isChecked: boolean): void {
    const normalizedContractId = Number(lo_id);
    const selectedOffer = this.upfrontOffers.find((offer: any) => Number(offer.lo_id) === normalizedContractId);

    if (selectedOffer) {
      selectedOffer.checked = isChecked;
    }

    this.normalizeUpfrontSelectionState();
  }

  confirmAcceptOffer(): void {
    if (!this.isUpfrontConsentChecked) {
      this._shared.customPopups('Please agree to the terms and conditions.', 1);
      return;
    }
    this.normalizeUpfrontSelectionState();
    if (this.modalSelectedUpfrontIds.length === 0) {
      this._shared.customPopups('Please select at least one contract.', 1);
      return;
    }

    const payload = {
      lo_id_arr: this.modalSelectedUpfrontIds
    }
    console.log(payload);
    
    
    this._api.api(payload, 'profile/accept_lendee_offer', 'post').subscribe((data: any) => {
      if (data && data.is_error == 0) {
        this.bsModalRef = this._modal.show(this.CONFIRM_ACCEPT_OFFER, { class: 'modal-dialog-centered' });
      }
    });
  }

  backToDashboard() {
    this.closeUpfrontPreview.emit();
    this.clearBackToDashboardTimer();
    if (this.fromPage === 'contract_details') {
      this.isModalPreview = false;
      return;
    }
    this.backToDashboardTimer = setTimeout(() => {
      this.isModalPreview = true;
      this.backToDashboardTimer = null;
    }, 1500);
  }

  ngOnDestroy(): void {
    this.clearBackToDashboardTimer();
  }

  private clearBackToDashboardTimer(): void {
    if (this.backToDashboardTimer) {
      clearTimeout(this.backToDashboardTimer);
      this.backToDashboardTimer = null;
    }
  }
}
